import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export const useSidebarWidth = (
  isCollapsed: boolean,
  showOnlySubNav?: boolean,
) => {
  if (showOnlySubNav) return { sidebarWidth: "", screenWidthMinusSidebar: "" };

  const sidebarWidth = cnTwMerge(
    isCollapsed ? "w-sidebar-collapsed" : "w-sidebar-expanded",
  );

  return {
    sidebarWidth,

    screenWidthMinusSidebar: isCollapsed
      ? "w-[calc(100vw-theme(width.sidebar-collapsed))]"
      : "w-[calc(100vw-theme(width.sidebar-expanded))]",
  };
};
